import { render, staticRenderFns } from "./Agentsetting.vue?vue&type=template&id=d5b0118c&"
import script from "./Agentsetting.vue?vue&type=script&lang=js&"
export * from "./Agentsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports